import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IResult } from 'app/shared/models/result.model';
import { IDtoPeriod } from 'app/shared/models/payroll/dto-period.model';
import { IDtoMovementRestrictionCalendar } from 'app/shared/models/payroll/dto-movement-restriction-calendar.model';
import { IDtoEmployeeUpdatePayroll } from 'app/shared/models/employee/dto-employee-update-payroll.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoCommissionPeriod } from 'app/shared/models/commission/dto-commission-period.model';
import { IDtoCommissionFilter } from 'app/shared/models/commission/dto-commission-filter.model';
import { IDtoCommissionPeriodDetail } from 'app/shared/models/commission/dto-commission-period-detail.model';
import { IDtoBonusPeriod } from 'app/shared/models/bonus/dto-bonus-period.model';
import { IDtoBonusPeriodDetail } from 'app/shared/models/bonus/dto-bonus-period-detail.model';
import { IDtoDocument } from 'app/shared/models/request/dto-document.model';
import { SecurityService } from '../../shared/services/security.service';

@Injectable()
export class CommissionService {
    private requestUrl = '';
    private roles: any;
    constructor(private service: DataService, private configurationService: ConfigurationService, private securityService: SecurityService) {
        if (this.configurationService.isReady) {
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.requestUrl = this.configurationService.serverSettings.requestUrl;
            });
        }
        let showRoles = this.securityService.getUserRolesStorage();
        if (showRoles == '' || showRoles == undefined) {

        } else {
            this.roles = showRoles.listRoles;
        }
    }
    public addCommissionPeriod(dto: IDtoCommissionPeriod): Observable<IResult> {
        const url = `${this.requestUrl}api/CommissionPeriods/addCommissionPeriod`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCatalogYears(): Observable<IDtoCatalog[]> {
        const url = `${this.requestUrl}api/CommissionPeriods/getCatalogsCommisionPeriodYears`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCommissionPeriodsByFilter(dto: IDtoCommissionFilter): Observable<IResult> {
        const url = `${this.requestUrl}api/CommissionPeriods/getCommissionPeriodsByFilter`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCommissionPeriodDetails(commissionPeriodId: number, userId: number, routeType: string, profile: string): Observable<IResult> {
        const url = `${this.requestUrl}api/CommissionPeriods/getCommissionPeriodDetailsByCommissionPeriodId?commissionPeriodId=${commissionPeriodId}&userId=${userId}&routeType=${routeType}&profile=${profile}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public updateComissionPeriodDetails(list: IDtoCommissionPeriodDetail[]): Observable<IResult> {
        list[0].userId = this.roles[0].userId;
        const url = `${this.requestUrl}api/CommissionPeriods/updateComissionPeriodDetails`;
        return this.service.putWithId(url, list).pipe(map((response: any) => {
            return response;
        }));
    }
    async actualizarComisiones(listaCompleta: any[], tamanoBloque: number): Promise<{ exito: boolean, mensaje: string }[]> {
        const resultados: { exito: boolean, mensaje: string }[] = [];

        for (let i = 0; i < listaCompleta.length; i += tamanoBloque) {
            const bloque = listaCompleta.slice(i, i + tamanoBloque);

            try {
                await this.service.putWithId(`${this.requestUrl}api/CommissionPeriods/updateComissionPeriodDetails`, bloque).toPromise();
                resultados.push({ exito: true, mensaje: `Bloque ${i / tamanoBloque + 1} actualizado correctamente.` });
            } catch (error) {
                resultados.push({ exito: false, mensaje: `Error al actualizar bloque ${i / tamanoBloque + 1}: ${error.message}` });
            }
        }

        return resultados;
    }
    public getBonusPeriodDetailsByCommissionPeriodIdAndBossId(commissionPeriodId: number, bossId: number): Observable<IResult> {
        const url = `${this.requestUrl}api/BonusPeriods/getBonusPeriodDetailsByCommissionPeriodIdAndBossId?commissionPeriodId=${commissionPeriodId}&bossId=${bossId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getBonusPeriodByCommissionPeriodId(commissionPeriodId: number): Observable<IResult> {
        const url = `${this.requestUrl}api/BonusPeriods/getBonusPeriodByCommissionPeriodId?commissionPeriodId=${commissionPeriodId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addBonusPeriod(dto: IDtoBonusPeriod): Observable<IResult> {
        const url = `${this.requestUrl}api/BonusPeriods/addBonusPeriod`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateBonusPeriodDetails(dto: IDtoBonusPeriod): Observable<IResult> {
        const url = `${this.requestUrl}api/BonusPeriods/updateBonusPeriodDetails`;
        return this.service.putWithId(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public deleteBonusPeriodDetailsEmployee(bonusPeriodId: number, employeeId: number, payrollId:number): Observable<IResult> {
        const url = `${this.requestUrl}api/BonusPeriods/deleteBonusPeriodDetailsEmployee?bonusPeriodId=${bonusPeriodId}&employeeId=${employeeId}&payrollId=${payrollId}`;
        return this.service.delete(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addBonusPeriodDetail(dto: IDtoBonusPeriodDetail): Observable<IResult> {
        const url = `${this.requestUrl}api/BonusPeriodDetails/addBonusPeriodDetail`;
        return this.service.post(url, dto).pipe(map((response: any) => {
            return response;
        }));
    }
    public sendCommissionPeriodsToCustomer(commissionPeriodId: number, approverUserId: string): Observable<IResult> {
        const url = `${this.requestUrl}api/CommissionPeriods/sendCommissionPeriodsToCustomer?commissionPeriodId=${commissionPeriodId}&approverUserId=${approverUserId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public downloadFileCommissions(commissionPeriodId: number): Observable<IResult> {

        const url = `${this.requestUrl}api/CommissionPeriods/getFileCommissionPeriodById?commissionPeriodId=${commissionPeriodId}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public addFileCommissions(item: IDtoDocument, fileToUpload: File): Observable<IResult> {
        const formData = new FormData();
        formData.append('document', JSON.stringify(item));
        formData.append('files', fileToUpload);

        const url = `${this.requestUrl}api/CommissionPeriods/uploadFileCommissionCustomer/`;
        return this.service.post(url, formData).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCommissionPeriodById(id: string, routeType: string): Observable<IDtoCommissionPeriod> {
        const url = `${this.requestUrl}api/CommissionPeriods/getCommissionPeriodById?id=${id}&routeType=${routeType}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCommissionPeriodDetailSummaryAmount(commissionPeriodId: number, userId: number, commissions: any[]): Observable<IResult> {
      const url = `${this.requestUrl}api/CommissionPeriods/getCommissionPeriodDetailSummaryAmount?commissionPeriodId=${commissionPeriodId}&bossId=${userId}`;

      return this.service.post(url, commissions)
          .pipe(
              map((res: any) => res)
          );
  }
    public UpdateCommissionInPayroll(commissionPeriodId: number, userId: number): Observable<IResult> {
      const url = `${this.requestUrl}api/CommissionPeriods/updateCommissionInPayroll?commissionPeriodId=${commissionPeriodId}&bossId=${userId}`;
      return this.service.get(url)
          .pipe(
              map((res: any) => {
                  return res;
              })
          );
    }
}
